module.exports = __webpack_public_path__ + "static/media/Compras9.db11d8ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCompras/Compras9.png
// module id = 2074
// module chunks = 0